import { render, staticRenderFns } from "./EditCarInfo.vue?vue&type=template&id=28a5ea28&scoped=true"
import script from "./EditCarInfo.vue?vue&type=script&lang=js"
export * from "./EditCarInfo.vue?vue&type=script&lang=js"
import style0 from "./EditCarInfo.vue?vue&type=style&index=0&id=28a5ea28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a5ea28",
  null
  
)

export default component.exports